var map = {
	"./core": 322,
	"./core.js": 322,
	"./event": 324,
	"./event.js": 324,
	"./fake_server": 325,
	"./fake_server.js": 325,
	"./fake_server_with_clock": 326,
	"./fake_server_with_clock.js": 326,
	"./fake_timers": 327,
	"./fake_timers.js": 327,
	"./fake_xdomain_request": 329,
	"./fake_xdomain_request.js": 329,
	"./fake_xml_http_request": 330,
	"./fake_xml_http_request.js": 330,
	"./timers_ie": 331,
	"./timers_ie.js": 331,
	"./xdr_ie": 332,
	"./xdr_ie.js": 332,
	"./xhr_ie": 333,
	"./xhr_ie.js": 333
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 323;



//////////////////
// WEBPACK FOOTER
// ./~/sinon/lib/sinon/util ^\.\/.*$
// module id = 323
// module chunks = 1